import { PickLocation } from '../types';
import { APIPickTour } from '../redux/sagas/types';
import { ORDER_TYPE_COMMERCIAL } from '../constants';

/**
 * Calculates the total picked quantity from an array of pick locations
 * @param locations - Array of pick locations
 * @returns Total picked quantity from all locations, or 0 if no locations
 */
export const getTotalPickedQuantity = (locations: PickLocation[] | undefined): number => {
  if (!locations || locations.length === 0) {
    return 0;
  }
  return locations.reduce((sum, location) => sum + location.pickedQuantity, 0);
};

/**
 * Checks if a pick tour is a bundled commercial order eligible for selective order resume
 * @param pickTour - The pick tour to check
 * @param editOrderEnabled - Whether edit order feature is enabled (defaults to false if undefined)
 * @returns True if this is a bundled commercial order with multiple orders and edit order is enabled
 */
export const isBundledCommercialWithEditOrder = (pickTour: APIPickTour, editOrderEnabled?: boolean): boolean => {
  return (
    pickTour.pickTourType === ORDER_TYPE_COMMERCIAL &&
    !!editOrderEnabled &&
    pickTour.metadata.ordersSummaryData.length > 1
  );
};
